import React from 'react'
import {MenuVariant, SanityImageType} from './components'

export type SlugType = {
	[locale: string]: {
		current: string,
	},
}

export type SanityPage = {
	_id?: string,
	_type: string,
	title: string,
	slug: string,
	allSlugs: SlugType,
	blocksCondensed: boolean,
	transparentHeader: boolean,
	menuVariant: MenuVariant,
	metaTitle: string,
	metaDescription: string,
	metaImage: SanityImageType,
}

export type PageProps = React.HTMLAttributes<HTMLElement> & SanityPage & {
	children?: React.ReactNode,
}

export type PageWithBlocksProps = PageProps & {
	blocks: unknown[],
	blocksComps?: React.ComponentType<unknown>[],
}
